export default function isRecoveredAbandonment(item) {
  if (!item || !item.isAbandoned) return false;

  return item.isAbandoned === true && item.recoveredAt != null;
}
